import { useCallback, useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import {
  startApproveEditionTheOrder,
  finishApproveEditionTheOrder,
} from '../../../../../actions/order.service';
import ActionModal from './ActionModal';

const ApproveEditionModal = ({ order, setOrder }) => {
  const { setLoading } = useContext(AuthContext);

  const uploadOrder = useCallback((response) => {
    if (!response.error) {
      response.delivery_date = new Date(response.delivery_date);

      if (response.payment_first_date) {
        response.payment_first_date = new Date(
          response.payment_first_date.replace(/-/g, ',')
        );
      }

      setOrder(response);
    }
  }, []);

  const getApproveEditionOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await startApproveEditionTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  const finishApproveEditionOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await finishApproveEditionTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  return (
    <>
      <ActionModal
        modal_id="modal-start-edit-inspection-order"
        title="iniciar Aprovação de edição do pedido?"
        action={getApproveEditionOrder}
        order={order}
      />

      <ActionModal
        modal_id="modal-finish-edit-inspection-order"
        title="finalizar aprovação de edição do pedido?"
        action={finishApproveEditionOrder}
        order={order}
      />
    </>
  );
};

ApproveEditionModal.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
  setOrder: PropTypes.func.isRequired,
};

export default ApproveEditionModal;
